export default __webpack_public_path__ + "static/media/AktivGrotesk-Light.0c81d287.ttf";